import React from 'react';
import { FileUploadItemProps } from './types';

export const FileUploadItem: React.FC<FileUploadItemProps> = ({
  file,
  onRemove
}) => {
  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 KB';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i)) + ' ' + sizes[i];
  };

  const isImage = file.file.type.startsWith('image/');
  const isPDF = file.file.type === 'application/pdf';

  return (
    <div className="file-upload__item">
      {/* プレビュー表示 */}
      {isImage && file.localPreviewUrl && (
        <div className="file-upload__preview">
          <img 
            src={file.localPreviewUrl} 
            alt={file.file.name}
          />
        </div>
      )}

      {/* PDFアイコン表示 */}
      {isPDF && (
        <div className="file-upload__pdf-icon">
          📄
        </div>
      )}

      {/* ファイル情報 */}
      <div className="file-upload__item-info">
        <span className="file-upload__item-name">{file.file.name}</span>
        <span className="file-upload__item-size">
          {formatFileSize(file.file.size)}
        </span>
      </div>

      {/* 削除ボタンのみ */}
      <div className="file-upload__actions">
        <button
          type="button"
          onClick={() => onRemove(file.id)}
          className="file-upload__remove-btn"
        >
          削除
        </button>
      </div>
    </div>
  );
};